import { withJsonFormsControlProps } from "@jsonforms/react";
import { Checkbox } from "pepsico-ds";
import { useEffect } from "react";

export const CheckboxArrayComponent = (props) => {
  const { data, handleChange, path, uischema, enabled, label, visible } = props;

  const parameters = uischema?.options?.parameters ?? [];
  const requiredParameters = uischema?.options?.requiredParameters ?? [];
  const isEmpty = !data || data.length === 0;
  const currentArray =
    isEmpty && requiredParameters.length > 0 ? requiredParameters : (data ?? []);

  useEffect(() => {
    if (!visible) return;
    const missingRequired = requiredParameters.filter(
      (p) => !(data ?? []).includes(p)
    );
    if (missingRequired.length > 0) {
      handleChange(path, [...(data ?? []), ...missingRequired]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  const handleToggle = (param, checked) => {
    if (requiredParameters.includes(param)) return;
    const next = checked
      ? [...currentArray, param]
      : currentArray.filter((p) => p !== param);
    handleChange(path, next);
  };

  if (!visible) return null;

  return (
    <div className="checkbox-array-control">
      {label && <p className="checkbox-array-label font-xsmall-regular">{label}</p>}
      {parameters.map((param) => (
        <Checkbox
          key={param}
          text={param}
          checked={currentArray.includes(param)}
          disabled={requiredParameters.includes(param) || !enabled}
          onUpdate={(checked) => handleToggle(param, checked)}
        />
      ))}
    </div>
  );
};

export const CheckboxArrayControl = withJsonFormsControlProps(
  CheckboxArrayComponent
);
